import { graphql, useStaticQuery } from "gatsby";

export const useCmsImages = () => {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter: { sourceInstanceName: { eq: "cms-media" } }) {
        nodes {
          relativePath
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
          }
        }
      }
    }
  `);

  return data.allFile.nodes;
};
